import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';

const TimeDisplay: React.FC = () => {
  const [currentTime, setCurrentTime] = useState<{
    utc: string;
    local: string;
  }>({
    utc: new Date().toISOString().replace('T', ' ').substring(0, 19),
    local: new Date().toLocaleString(),
  });

  useEffect(() => {
    // Update time every second
    const interval = setInterval(() => {
      const now = new Date();
      setCurrentTime({
        utc: now.toISOString().replace('T', ' ').substring(0, 19),
        local: now.toLocaleString(),
      });
    }, 1000);

    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
        UTC: {currentTime.utc}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
        Local: {currentTime.local}
      </Typography>
    </Box>
  );
};

export default TimeDisplay;